import { computed } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { queryEnquireCurrency } from '@/graphql/holdings'
import Decimal from 'decimal.js'

interface CurrencyRateItem {
  ccy: string
  baseCcy: string
  rate: number | string
}

export default function useEnquireCurrency() {
  const { result, loading, refetch } = useQuery(queryEnquireCurrency)

  const currencyRates = computed<CurrencyRateItem[]>(() => {
    const data = result.value?.EnquireCurrency?.data
    return Array.isArray(data) ? data : []
  })

  const getRate = (targetCcy: string): number | null => {
    const code = String(targetCcy || '').toUpperCase()
    if (!code) return null
    const directRate = currencyRates.value.find(item => item.ccy === code)?.rate
    const rate = Number(directRate)
    return Number.isFinite(rate) && rate > 0 ? rate : null
  }

  // amount: 原金额
  // fromCcy: 原币种（如 USD）
  // toCcy: 目标币种（如 CNY）
  const convertCurrencyAmount = (
    amount: number | string,
    fromCcy: string,
    toCcy: string
  ): number | null => {
    const value = Number(amount)
    if (!Number.isFinite(value)) return null

    const from = String(fromCcy || '').toUpperCase()
    const to = String(toCcy || '').toUpperCase()
    if (!from || !to || from === to) return value

    const fromRate = getRate(from) // 相对 HKD
    const toRate = getRate(to) // 相对 HKD
    if (!fromRate || !toRate) return null

    // amount * fromRate / toRate
    return new Decimal(value).mul(fromRate).div(toRate).toNumber()
  }

  return {
    loading,
    refetch,
    currencyRates,
    getRate,
    convertCurrencyAmount
  }
}
